import React from 'react';
import { ZapIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';

/**
 * Aislado en su propio componente para que el tick de cada segundo
 * no vuelva a renderizar todo el bloque de oferta.
 */
export function Countdown() {
  const {
    minutes,
    seconds
  } = useCountdown(600);
  const units = [{
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEG'
  }];
  return <div className="mt-4 rounded-2xl border border-coral/25 bg-cream px-5 py-6 text-center" data-id="element-24" data-mp="3c0unla60qs8y">
      <p className="flex items-center justify-center gap-2 font-display text-[19px] font-semibold uppercase text-coral" data-id="element-25" data-mp="3h18weufg2681">
        <ZapIcon aria-hidden="true" className="h-5 w-5" strokeWidth={2.2} data-id="element-26" data-mp="324zxjtzgtuw5" />
        Disponible solo 100 packs
      </p>
      <div className="mt-5 flex items-start justify-center gap-2" data-id="element-27" data-mp="3731fucp2hq6k">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-28" data-mp="10a8te5k4rtwv" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" className="font-display text-[30px] font-semibold leading-none text-ink/20" data-id="element-29" data-mp="15a50ido4k1gn">
                :
              </span>}
            <div className="min-w-[76px] rounded-xl bg-blush/70 px-3 py-3" data-id="element-30" data-mp="t1tn5u9nte9c">
              <p className="font-display text-[34px] font-semibold leading-none tabular-nums text-ink" data-id="element-31" data-mp="17pybbdrhehzi">
                {unit.value}
              </p>
              <p className="mt-1.5 font-sans text-[11px] font-medium tracking-[0.16em] text-muted" data-id="element-32" data-mp="f2arw21y5xeg">
                {unit.label}
              </p>
            </div>
          </React.Fragment>)}
      </div>
      <p className="mt-5 font-sans text-[14px] leading-relaxed text-ink-soft" data-id="element-33" data-mp="o2qul9av90i9">
        Reserva válida por 10 minutos. Si no accedés, tu descuento pasa a la
        siguiente persona.
      </p>
    </div>;
}